// Generat automat din README.md - Gestionar documente HR pentru Margarit Alexandru Florian
import React, { useState } from 'react';
import { FileText, Users, Upload, Download, Search, Filter, Eye, Edit, Trash2, Plus, FolderOpen, Calendar, Award, CheckCircle, XCircle, Clock, User, Building } from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const GestionareCVuri = () => {
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [filterType, setFilterType] = useState('Toate');
  const [searchTerm, setSearchTerm] = useState('');

  // Documente HR pentru Margarit Alexandru Florian - Proprietarul/Angajatul unic
  const hrData = {
    overview: {
      totalDocuments: 12,
      contracts: 3,
      certificates: 5,
      personalDocs: 4
    },
    documents: [
      {
        id: 1,
        documentName: 'CV Margarit Alexandru Florian',
        documentType: 'CV Personal',
        category: 'Document Personal',
        uploadDate: '2023-01-10',
        lastUpdated: '2024-02-15',
        status: 'Activ',
        fileSize: '1.2 MB',
        fileName: 'CV_Margarit_Alexandru_Florian_2024.pdf',
        description: 'CV actualizat cu experiența în industria de catering pentru evenimente speciale'
      },
      {
        id: 2,
        documentName: 'Contract de Înființare Societate',
        documentType: 'Contract Legal',
        category: 'Document Legal',
        uploadDate: '2023-01-15',
        lastUpdated: '2023-01-15',
        status: 'Activ',
        fileSize: '0.8 MB',
        fileName: 'Contract_Infiintare_Botez_de_Poveste.pdf',
        description: 'Documentul de înființare a societății Botez de poveste'
      },
      {
        id: 3,
        documentName: 'Certificat Cursuri Design Torturi',
        documentType: 'Certificat',
        category: 'Dezvoltare Profesională',
        uploadDate: '2023-03-20',
        lastUpdated: '2023-03-20',
        status: 'Valid',
        fileSize: '0.5 MB',
        fileName: 'Certificat_Design_Torturi_2023.pdf',
        description: 'Certificat absolvire curs specializat în design și decorare torturi pentru evenimente'
      },
      {
        id: 4,
        documentName: 'Licență Activitate Comercială',
        documentType: 'Licență',
        category: 'Document Legal',
        uploadDate: '2023-02-01',
        lastUpdated: '2024-02-01',
        status: 'Reînnoit',
        fileSize: '0.3 MB',
        fileName: 'Licenta_Comerciala_2024.pdf',
        description: 'Licența pentru desfășurarea activității comerciale în domeniul catering evenimente'
      },
      {
        id: 5,
        documentName: 'Certificat HACCP Siguranța Alimentelor',
        documentType: 'Certificat',
        category: 'Certificare Profesională',
        uploadDate: '2023-04-10',
        lastUpdated: '2023-04-10',
        status: 'Valid până în 2026',
        fileSize: '0.4 MB',
        fileName: 'Certificat_HACCP_Margarit_2023.pdf',
        description: 'Certificat pentru manipularea alimentelor și siguranța produselor'
      },
      {
        id: 6,
        documentName: 'Asigurare Răspundere Civilă',
        documentType: 'Asigurare',
        category: 'Document Legal',
        uploadDate: '2024-01-15',
        lastUpdated: '2024-01-15',
        status: 'Activ până în 2025',
        fileSize: '0.6 MB',
        fileName: 'Asigurare_RC_Profesionala_2024.pdf',
        description: 'Asigurare de răspundere civilă profesională pentru activitatea de catering'
      },
      {
        id: 7,
        documentName: 'Diplomă Absolvire Facultate',
        documentType: 'Diplomă',
        category: 'Educație',
        uploadDate: '2023-01-05',
        lastUpdated: '2023-01-05',
        status: 'Permanent',
        fileSize: '0.9 MB',
        fileName: 'Diploma_Facultate_Margarit.pdf',
        description: 'Diplomă de licență în domeniul economic/management'
      },
      {
        id: 8,
        documentName: 'Contracte Furnizori Principali',
        documentType: 'Contract',
        category: 'Document Legal',
        uploadDate: '2023-06-01',
        lastUpdated: '2024-01-10',
        status: 'Actualizat',
        fileSize: '2.1 MB',
        fileName: 'Contracte_Furnizori_2024.pdf',
        description: 'Contracte cu furnizorii principali de ingrediente și materiale'
      },
      {
        id: 9,
        documentName: 'Evaluare Anuală Performanță 2023',
        documentType: 'Evaluare',
        category: 'Performanță',
        uploadDate: '2024-01-30',
        lastUpdated: '2024-01-30',
        status: 'Finalizat',
        fileSize: '0.7 MB',
        fileName: 'Evaluare_Performanta_2023.pdf',
        description: 'Auto-evaluare și obiective pentru anul 2024'
      },
      {
        id: 10,
        documentName: 'Plan Afaceri 2024',
        documentType: 'Plan Strategic',
        category: 'Strategie',
        uploadDate: '2023-12-15',
        lastUpdated: '2024-02-01',
        status: 'În implementare',
        fileSize: '1.8 MB',
        fileName: 'Plan_Afaceri_2024.pdf',
        description: 'Planul de dezvoltare a afacerii pentru anul curent'
      },
      {
        id: 11,
        documentName: 'Inventar Echipamente Profesionale',
        documentType: 'Inventar',
        category: 'Resurse',
        uploadDate: '2024-03-01',
        lastUpdated: '2024-03-01',
        status: 'Actualizat',
        fileSize: '1.1 MB',
        fileName: 'Inventar_Echipamente_2024.pdf',
        description: 'Lista echipamentelor și ustinsilelor utilizate în producție'
      },
      {
        id: 12,
        documentName: 'Portfolio Proiecte Finalizate',
        documentType: 'Portfolio',
        category: 'Prezentare',
        uploadDate: '2024-02-20',
        lastUpdated: '2024-03-10',
        status: 'Actualizat Regular',
        fileSize: '3.2 MB',
        fileName: 'Portfolio_Botezuri_2024.pdf',
        description: 'Portfolio cu fotografii și detalii despre botezurile organizate'
      }
    ]
  };

  // Filtrarea documentelor
  const filteredDocuments = hrData.documents.filter(doc => {
    const matchesSearch = doc.documentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         doc.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = filterType === 'Toate' || doc.category === filterType;
    return matchesSearch && matchesFilter;
  });

  const handleViewDocument = (document) => {
    setSelectedDocument(document);
    setShowDocumentModal(true);
  };

  const handleDownload = (document) => {
    // Simulare download
    alert(`Se descarcă: ${document.fileName}`);
  };

  const columns = [
    {
      header: 'Document',
      key: 'documentName',
      render: (value, row) => (
        <div>
          <p className="font-semibold text-gray-900 dark:text-white">{value}</p>
          <p className="text-sm text-gray-500">{row.documentType}</p>
        </div>
      )
    },
    {
      header: 'Categorie',
      key: 'category',
      render: (value) => (
        <Badge variant="info">{value}</Badge>
      )
    },
    {
      header: 'Încărcat',
      key: 'uploadDate'
    },
    {
      header: 'Status',
      key: 'status',
      render: (value) => {
        const variant = 
          value.includes('Activ') || value.includes('Valid') || value.includes('Finalizat') ? 'success' :
          value.includes('Actualizat') || value.includes('implementare') ? 'info' :
          value.includes('Reînnoit') ? 'warning' : 'default';
        return <Badge variant={variant}>{value}</Badge>;
      }
    },
    {
      header: 'Mărime',
      key: 'fileSize'
    },
    {
      header: 'Acțiuni',
      key: 'actions',
      render: (value, row) => (
        <div className="flex space-x-2">
          <button
            onClick={() => handleViewDocument(row)}
            className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
            title="Vezi detalii"
          >
            <Eye className="w-4 h-4" />
          </button>
          <button
            onClick={() => handleDownload(row)}
            className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-colors"
            title="Descarcă"
          >
            <Download className="w-4 h-4" />
          </button>
        </div>
      )
    }
  ];

  const categories = ['Toate', ...new Set(hrData.documents.map(doc => doc.category))];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white flex items-center gap-3">
            <FileText className="w-8 h-8 text-blue-500" />
            Gestionare Documente HR - Margarit Alexandru Florian
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Arhivă digitală cu toate documentele importante ale proprietarului
          </p>
        </div>
        
        <div className="flex gap-3">
          <button 
            onClick={() => setShowUploadModal(true)}
            className="btn-primary flex items-center gap-2"
          >
            <Plus className="w-4 h-4" />
            Document Nou
          </button>
        </div>
      </div>

      {/* Statistici */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <Card title="Total Documente" icon={FileText} variant="stats">
          <div className="text-3xl font-bold text-blue-600">
            {hrData.overview.totalDocuments}
          </div>
          <p className="text-sm text-gray-500 mt-1">Documente arhivate</p>
        </Card>

        <Card title="Contracte" icon={Building} variant="stats">
          <div className="text-3xl font-bold text-green-600">
            {hrData.overview.contracts}
          </div>
          <p className="text-sm text-gray-500 mt-1">Contracte active</p>
        </Card>

        <Card title="Certificate" icon={Award} variant="stats">
          <div className="text-3xl font-bold text-yellow-600">
            {hrData.overview.certificates}
          </div>
          <p className="text-sm text-gray-500 mt-1">Certificate valide</p>
        </Card>

        <Card title="Doc. Personale" icon={User} variant="stats">
          <div className="text-3xl font-bold text-purple-600">
            {hrData.overview.personalDocs}
          </div>
          <p className="text-sm text-gray-500 mt-1">Documente personale</p>
        </Card>
      </div>

      {/* Info despre proprietar */}
      <Card>
        <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
          <div className="flex items-start">
            <User className="w-5 h-5 text-blue-500 mt-0.5 mr-3" />
            <div>
              <h3 className="text-sm font-medium text-blue-800 dark:text-blue-200">
                Proprietar și Angajat Unic
              </h3>
              <p className="mt-2 text-sm text-blue-700 dark:text-blue-300">
                Această arhivă conține toate documentele importante ale lui <strong>Margarit Alexandru Florian</strong>, 
                proprietarul și singurul angajat al companiei "Botez de poveste". Documentele includ contracte legale, 
                certificate profesionale, documente personale și planuri strategice pentru dezvoltarea afacerii.
              </p>
            </div>
          </div>
        </div>
      </Card>

      {/* Căutare și filtrare */}
      <Card>
        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
          <div className="flex-1 relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
            <input
              type="text"
              placeholder="Caută documente după nume sau descriere..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            />
          </div>
          
          <select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          >
            {categories.map(category => (
              <option key={category} value={category}>{category}</option>
            ))}
          </select>
        </div>
      </Card>

      {/* Tabel documente */}
      <Card title={`Documente Arhivate (${filteredDocuments.length})`}>
        <Table 
          columns={columns} 
          data={filteredDocuments}
          onRowClick={handleViewDocument}
        />
      </Card>

      {/* Modal Vizualizare Document */}
      <Modal
        isOpen={showDocumentModal}
        onClose={() => setShowDocumentModal(false)}
        title={`Detalii Document - ${selectedDocument?.documentName}`}
        size="lg"
      >
        {selectedDocument && (
          <div className="space-y-6">
            <div className="bg-gradient-to-r from-blue-50 to-green-50 dark:from-blue-900/20 dark:to-green-900/20 p-6 rounded-lg">
              <div className="flex items-start justify-between">
                <div className="flex items-center space-x-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-green-600 rounded-full flex items-center justify-center text-white">
                    <FileText className="w-8 h-8" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white">
                      {selectedDocument.documentName}
                    </h3>
                    <p className="text-gray-600 dark:text-gray-300">
                      {selectedDocument.documentType}
                    </p>
                    <Badge variant="info" className="mt-2">
                      {selectedDocument.category}
                    </Badge>
                  </div>
                </div>
                
                <div className="text-right">
                  <Badge 
                    variant={selectedDocument.status.includes('Activ') ? 'success' : 'info'}
                  >
                    {selectedDocument.status}
                  </Badge>
                  <p className="text-sm text-gray-500 mt-2">
                    {selectedDocument.fileSize}
                  </p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h4 className="font-semibold text-gray-900 dark:text-white mb-2">Informații Document</h4>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-500">Data încărcării:</span>
                    <span>{selectedDocument.uploadDate}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Ultima actualizare:</span>
                    <span>{selectedDocument.lastUpdated}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Numele fișierului:</span>
                    <span className="text-blue-600">{selectedDocument.fileName}</span>
                  </div>
                </div>
              </div>

              <div>
                <h4 className="font-semibold text-gray-900 dark:text-white mb-2">Descriere</h4>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {selectedDocument.description}
                </p>
              </div>
            </div>

            <div className="flex justify-end space-x-3 pt-4 border-t">
              <button
                onClick={() => handleDownload(selectedDocument)}
                className="btn-secondary flex items-center gap-2"
              >
                <Download className="w-4 h-4" />
                Descarcă
              </button>
              <button
                onClick={() => setShowDocumentModal(false)}
                className="btn-secondary"
              >
                Închide
              </button>
            </div>
          </div>
        )}
      </Modal>

      {/* Modal Încărcare Document */}
      <Modal
        isOpen={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        title="Încarcă Document Nou"
        size="md"
      >
        <div className="space-y-6">
          <div className="text-center p-8 border-2 border-dashed border-gray-300 rounded-lg">
            <Upload className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <p className="text-gray-600 dark:text-gray-400">
              Trage și lasă fișierul aici sau
            </p>
            <button className="text-blue-600 hover:text-blue-700 font-medium">
              alege fișierul
            </button>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Numele documentului</label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              placeholder="Introdu numele documentului..."
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Categoria</label>
            <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:border-gray-600 dark:text-white">
              <option value="">Selectează categoria...</option>
              <option value="Document Personal">Document Personal</option>
              <option value="Document Legal">Document Legal</option>
              <option value="Certificare Profesională">Certificare Profesională</option>
              <option value="Dezvoltare Profesională">Dezvoltare Profesională</option>
              <option value="Strategie">Strategie</option>
              <option value="Resurse">Resurse</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Descriere</label>
            <textarea
              rows="3"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              placeholder="Descrierea documentului..."
            />
          </div>

          <div className="flex justify-end space-x-3 pt-4 border-t">
            <button
              onClick={() => setShowUploadModal(false)}
              className="btn-secondary"
            >
              Anulează
            </button>
            <button className="btn-primary flex items-center gap-2">
              <Upload className="w-4 h-4" />
              Încarcă Document
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default GestionareCVuri;